import namespace from './namespace';
export default  {
	[namespace.getters.HIERARCHY_STATE]: (state) => {
		return state[namespace.state.HIERARCHY_STATE];
	},
	[namespace.getters.IS_EPIC_TYPE_MAPPED]: (state) => {
		return state[namespace.state.IS_EPIC_TYPE_MAPPED];
	},
	[namespace.getters.IS_EPIC_NAME_MAPPED]: (state) => {
		return state[namespace.state.IS_EPIC_NAME_MAPPED];
	},
	[namespace.getters.IS_NEXT_GEN]: (state) => {
		return state[namespace.state.IS_NEXT_GEN];
	},
	[namespace.getters.AVAILABLE_JIRA_VALUES]: (state) => {
		const availableJiraValues = state[namespace.state.AVAILABLE_JIRA_VALUES];
		const hierarchy = state[namespace.state.HIERARCHY_STATE];
		availableJiraValues.forEach(function(value) {
			value.title = value.regularTitle;
			if (hierarchy.JiraLinkIsInverted) {
				value.title = value.invertedTitle;
			}
		});
		return availableJiraValues;
	},
	[namespace.getters.JIRA_LINK_TITLE]:(state) => {
		return state[namespace.state.SELECTED_JIRA_LINK];
	},
	[namespace.getters.WAITING_FOR_RESPONSE]: (state) => {
		return state[namespace.state.WAITING_FOR_RESPONSE];
	}
};



// WEBPACK FOOTER //
// ./src/store/modules/hierarchy/getters.js